import moment from 'moment';

export const columns = ({ t }) => [
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Description'),
    name: 'description'
  },
  {
    title: t('Last Updated At'),
    name: 'updatedAt'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const mockedRows = [];

export const formatData = (items, t) =>
  items.map(item => ({
    id: item.id,
    name: item.name,
    description: item.description,
    status: item.active ? t('Active') : t('Inactive'),
    expired: item.active,
    updatedAt: moment(item.changedUtc)
      .format('ll')
      .toUpperCase(),
    rowVersion: String(item.rowVersion)
  }));

export default {
  columns,
  mockedRows,
  formatData
};
